import React from 'react';
import ListItemPerson from '../AbstractComboBox/ListItemPerson/ListItemPerson';
import { TopUserResult } from '../AbstractComboBox/types/SuggestResultTypes';
import AbstractFormsComboBox, { FormsComboBoxProps } from '../AbstractComboBox/AbstractFormsComboBox';
import ListItemEmpty from '../AbstractComboBox/ListItemEmpty/ListItemEmpty';
import { ComboBoxInputProps } from '../AbstractComboBox/hooks/useComboBoxInput';
import { useHtmlValidId } from '../../../../../../hooks/useHtmlValidId';

export default function UserComboBox(props: ComboBoxInputProps & FormsComboBoxProps<TopUserResult>) {
  return (
    <AbstractFormsComboBox {...props}>
      {item => (item ? <ListItemPerson user={item} withEmail /> : <ListItemEmpty />)}
    </AbstractFormsComboBox>
  );
}

/**
 * Form2 compatible UserComboBox.
 * As with most comboboxes the name of the input should not be set.
 * Combobox is responsible to set hidden param, html conform json payload.
 */
export function UserComboBoxForForm2(
  props: ComboBoxInputProps & Omit<FormsComboBoxProps<TopUserResult>, 'name' | 'id'>
) {
  const id = useHtmlValidId();

  return <UserComboBox {...props} name={undefined} id={`user-combobox-${id}`} />;
}
